import { useIntl } from 'react-intl';

export const useFormatDistance = () => {
  const intl = useIntl();
  return (distance: number) => intl.formatNumber(distance, { style: 'decimal', maximumFractionDigits: 2 });
};
